import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {roleRequestSchema} from "../../utils/schemas";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useAuth} from "../../context/auth";
import {useGlobalNotificationMessage} from "../../context/message";
import {useRoleService} from "../../services/role-service";
import {useAuthService} from "../../services/auth-service";

const AddEditRoleModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState(0);

  let formSchema = roleRequestSchema;

  let roleService = useRoleService();
  let auth = useAuth();
  let authService = useAuthService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null) => {
    setLoading(true);
    if (model && model.id){
      getDetail(model.id).then((detail)=>{
        setModel(formSchema.cast(detail));
      }).catch((error)=>{
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa nanačítať detail");
      }).finally(()=>{
        setLoading(false);
      });
    } else {
      setModel(formSchema.cast());
      setLoading(false);
    }
    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const getDetail = (id) => {
    return roleService.getDetail(id);
  }

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    roleService.addEditModel(values, values.id)
      .then((res) => {
        if (auth.currentUser._all_roles.includes(values.name)){
          authService.getUser().then((user)=>{
            auth.setCurrentUser(user);
          })
        }
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{setSubmitting(false);});
  };

  return (
    <>
      <Formik
        key={reset}
        enableReinitialize={true}
        initialValues={model || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit }) => (

          <Modal size="xl" show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>{ !model.id ? 'Nová rola' : 'Úprava role' }</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}


                {!loading && <Form className="row">

                  <FormGroup
                    name="title"
                    placeholder="Názov role"
                    label="Názov role"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="name"
                    placeholder="unikatny-kluc"
                    label="Unikátny klúč pre rolu"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>
    </>
  );
});

export default AddEditRoleModal;
